import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/content';

const { FiMail, FiPhone, FiTwitter, FiLinkedin, FiGithub, FiArrowRight } = FiIcons;

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang].footer;
  const p = translations[lang].paths;

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiArrowRight} className="text-white text-sm" />
              </div>
              <span className="text-xl font-bold">Stup-On</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">{t.desc}</p>
            <div className="flex space-x-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiTwitter} className="text-xl" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiLinkedin} className="text-xl" />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiGithub} className="text-xl" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t.quickLinks}</h3>
            <ul className="space-y-3">
              <li><Link to={p.home} className="text-gray-400 hover:text-white transition-colors">{lang === 'en' ? 'Home' : 'Startseite'}</Link></li>
              <li><Link to={p.steps} className="text-gray-400 hover:text-white transition-colors">{lang === 'en' ? '10 Steps' : '10 Schritte'}</Link></li>
              <li><Link to={p.contact} className="text-gray-400 hover:text-white transition-colors">{lang === 'en' ? 'Contact' : 'Kontakt'}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t.contact}</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-400">
                <SafeIcon icon={FiMail} className="text-sm" />
                <span>hello@stup-on.de</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <SafeIcon icon={FiPhone} className="text-sm" />
                <span>+49 (0) 30 12345678</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">{t.rights}</p>
            <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2 mt-4 md:mt-0">
              <Link to={p.legal} className="text-gray-400 hover:text-white text-sm transition-colors">{t.legal}</Link>
              <Link to={p.privacy} className="text-gray-400 hover:text-white text-sm transition-colors">{t.privacy}</Link>
              <Link to={p.terms} className="text-gray-400 hover:text-white text-sm transition-colors">{t.terms}</Link>
              <Link to={p.cookies} className="text-gray-400 hover:text-white text-sm transition-colors">{t.cookies}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;